// useAppId — Extract appId from URL params and sync with AppsContext.
// Pages use this instead of reading currentApp from context directly.
// The URL is the source of truth for which app is active.

import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useApps } from '@/contexts/AppsContext';

export function useAppId() {
  const { appId } = useParams();
  const { apps, currentApp, selectApp } = useApps();

  // Sync context with URL param
  useEffect(() => {
    if (appId && (!currentApp || currentApp.appId !== appId)) {
      const app = apps.find(a => a.appId === appId);
      if (app) selectApp(app);
    }
  }, [appId, apps, currentApp, selectApp]);

  return appId;
}
